export default {
    enter_address: 'Пожалуйста, введите ваш адрес',
    edit_address: 'Изменить адрес',
    enter_address_here: 'Введите ваш адрес здесь',
    buttons: {
        create_new: 'Добавить местоположение',
        back: 'Назад',
    },
    only_supported_country:
        'Мы в настоящее время поддерживаем Сербию и Боснию и Герцеговину! Мы работаем над расширением нашего покрытия и на другие страны.',
    company_bosnia_country:
        'Адрес компании находится в Боснии и Герцеговине, и можно добавлять только местоположения из Боснии и Герцеговины.',
    company_serbia_country:
        'Адрес компании находится в Боснии и Герцеговине, и можно добавлять только местоположения из Боснии и Герцеговины.',
    deleted_success: 'Местоположение успешно удалено!',
    no_locations: 'У вас нет добавленных местоположений!',
}
